export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10476.bd8b499e.jpg";